import React, { useCallback, useState } from 'react';
import { BindUseDropzone } from './bind-use-dropzone';
import Debug from 'debug';
import { UseDropzoneOptions } from './use-dropzone-options';
import { UseDropzoneState } from './use-dropzone-state';
import { useDebouncedState } from '../use-debounced-state';

const debug = Debug('mint:ui:use-dropzone');

export const useDropzone = (
  options: UseDropzoneOptions = {},
): [UseDropzoneState, BindUseDropzone] => {
  const [dragOver, setDragOver] = useDebouncedState(false, 100);

  const onDragEnter = useCallback(
    (e: React.DragEvent): void => {
      debug('drag enter');
      e.preventDefault();
      e.stopPropagation();
      setDragOver(true);
      if (options.onDragEnter) {
        options.onDragEnter(e);
      }
    },
    [options.onDragEnter],
  );

  const onDragLeave = useCallback(
    (e: React.DragEvent): void => {
      debug('drag leave');
      setDragOver(false);
      if (options.onDragLeave) {
        options.onDragLeave(e);
      }
    },
    [options.onDragLeave],
  );

  const onDragOver = useCallback(
    (e: React.DragEvent): void => {
      debug('drag over');
      e.preventDefault();
      // setDragOver(true);
      if (options.onDragOver) {
        options.onDragOver(e);
      }
    },
    [options.onDragOver],
  );

  const onDrop = useCallback(
    (e: React.DragEvent): void => {
      debug('drop');
      e.preventDefault();
      e.stopPropagation();
      setDragOver(false);
      if (options.onDrop) {
        options.onDrop(e);
      }
      if (options.onFiles) {
        const { files } = e.dataTransfer;
        options.onFiles(files);
      }
    },
    [options.onDrop],
  );

  const state: UseDropzoneState = {
    dragOver,
  };

  const bind: BindUseDropzone = {
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop,
  };

  return [state, bind];
};
